import { Component } from "react";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import { connect } from "react-redux";

import SidebarMenuItems from "./items"; 
import pages from "../../constants/menu";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: "",
      submenu: false,
    };
  }

  get menuItems() {
    return pages[0].contains.items;
  }

  onPermitted = (named) => {
    const __permissions = (Array.isArray(named)) ? named : [named];
    return this.props.auth.permissions.some(item => __permissions.includes(item));
  }

  onShowSubmenu = (e, item) => {
    this.setState({
      item: item.id,
      submenu: !this.state.submenu,
    });
    return false;
  };

  onClick = (e, item) => {
    this.props.history.push(item.to);
  };

  onMouseOver = (e, item) => {
    this.setState({
      ...this.state,
      show: true,
    });
  }

  onMouseOut = (e, item) => {
    this.setState({
      ...this.state,
      show: false,
    });
  }

  render() {
    if (!this.props.auth) return;
    return (
      <Col xs="auto" className="side-menu-container" style={{ width: `${this.props.width ?? 150}px` }}>
        <ul className="sw-25 side-menu mb-0 primary" id="menuSide" style={{ width: "100%" }} onMouseEnter={this.onMouseOver} onMouseLeave={this.onMouseOut}>
          <SidebarMenuItems items={pages[0].contains.items} onPermitted={this.onPermitted} />
        </ul>
      </Col>
    )
  }
}

Sidebar.propTypes = {
  auth: PropTypes.object.isRequired,
  width: PropTypes.number,
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(Sidebar);
